export default __webpack_public_path__ + "static/media/angpao.0cc846da.webp";